export default __webpack_public_path__ + "static/media/flash.62021dbf.png";